import { SET_MESSAGE_CONCLUSAO } from './types';

const initialState = {
  title: '',
  description: '',
  icon: '',
  error: '',
  isError:false 
}
export default function conclusaoReducer(state = initialState, action) {

  switch(action.type){
    case SET_MESSAGE_CONCLUSAO: return {...state, ...action.payload };
    default: return state;
  }
}